<template>
  <div>
    <!-- Page Header -->
    <div class="page-header">
      <div class="header-icon-wrap">
        <i class="fe fe-user-plus"></i>
      </div>
      <div>
        <h2 class="page-header-title">Offline Enrollment</h2>
        <p class="page-header-subtitle">Bio data form — all required fields must be completed</p>
      </div>
    </div>

    <div class="container mt-n3 pb-5">

      <!-- Sync alert -->
      <div class="alert-sync d-flex align-items-center mb-4" v-if="localStudentCount > 0">
        <i class="fe fe-upload-cloud mr-3" style="font-size:1.4rem;"></i>
        <div class="flex-grow-1">
          <strong>{{ localStudentCount }} record{{ localStudentCount > 1 ? 's' : '' }} ready to sync</strong>
          <p class="mb-0 small" style="opacity:.8;">Upload these records when you're back online.</p>
        </div>
        <router-link :to="{ path: '/offline-sync' }" class="btn btn-sync ml-3">
          <i class="fe fe-upload-cloud mr-1"></i> Sync Now
        </router-link>
      </div>

      <!-- Bio Data Form Card -->
      <div class="card info-card shadow-sm mb-4" v-show="showinput">
        <div class="info-card-header">
          <i class="fe fe-file-text mr-2"></i> Bio Data Form
          <span class="ml-2 small font-weight-normal" style="opacity:.8;">Fields marked <span class="text-warning">*</span> are required</span>
        </div>
        <div class="card-body">

          <div class="col-md-12" v-show="showinput">
            <div class="text-center" style="display:none">
              <h3 class="h3">(Offline) Bio Data Form</h3>
              <p>
                (All fields marked with <span class="text-danger">*</span> are
                compulsory)
              </p>
            </div>

            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="inputCity">Select Sector <span class="text-danger">*</span></label>
                <select class="form-control" v-model="sector" disabled>
                  <option value="formal">Formal Sector</option>
                  <option value="informal">Informal Sector</option>
                </select>
              </div>

              <!-- <div class="form-group col-md-12">
                <label for="inputCity">Select Plan Type <span class="text-danger">*</span></label>
                <select class="form-control" v-model="newStudent.plan_type">
                  <option value="Family">Family</option>
                  <option value="Individual">Individual</option>
                </select>
              </div> -->

              <div class="col-md-12" v-if="sector == 'formal'">
                <div class="form-group">
                  <label for="inputCity">Select Formal Sector</label>
                  <select class="form-control" v-model="newStudent.sector">
                    <option value="State Civil Servant">
                      State Civil Servant
                    </option>
                    <option value="LGA Civil Servant">LGA Civil Servant</option>
                    <option value="Tertiary Student Health Insurance Plan (T-SHIP)">
                      Tertiary Student Health Insurance Plan (T-SHIP)
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group col-md-6" v-if="sector == 'informal'">
                <label>Informal Sector <span class="text-danger">*</span></label>
                <select class="form-control" v-model="newStudent.sector">
                  <option :value="sector.name" v-for="sector in sectors" :key="sector.agency_id">
                    {{sector.name}}
                  </option>

                </select>
              </div>

              <div class="form-group col-md-6" v-if="sector == 'informal'">
                <label>Special Needs <span class="text-danger">*</span></label>
                <select class="form-control" v-model="newStudent.category_of_vulnerable_group" required>

                  <option :value="vulnerable.name" v-for="vulnerable in vulnerables" :key="vulnerable.agency_id">
                    {{vulnerable.name}}
                  </option>


                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="inputPassword4">NIN <span class="text-danger">*</span> </label>
                <input type="text" inputmode="numeric" class="form-control" maxlength="11"
                  v-model="newStudent.nimc_number"
                  @input="newStudent.nimc_number = newStudent.nimc_number.replace(/\D/g, '').slice(0, 11)"
                  placeholder="NIN (11 digits)" required />
                <p class="text-danger" v-if="newStudent.nimc_number && newStudent.nimc_number.length !== 11">
                  NIN must be exactly 11 digits ({{ newStudent.nimc_number.length }})
                </p>
              </div>
              <div class="form-group col-md-6">
                <label for="inputPassword4">Surname <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="newStudent.lastname" placeholder="Last Name" />
              </div>
              <div class="form-group col-md-6">
                <label for="inputEmail4">First Name<span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="newStudent.firstname" placeholder="First Name" />
              </div>
              <div class="form-group col-md-6">
                <label for="inputEmail4">Middle Name</label>
                <input type="text" class="form-control" v-model="newStudent.middlename" placeholder="Middle Name" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="inputPassword4">Phone Number <span class="text-danger">*</span></label>
                <input type="text" inputmode="numeric" class="form-control" maxlength="11" v-model="client_number"
                  @input="client_number = client_number.replace(/\D/g, '').slice(0, 11)"
                  placeholder="Phone Number (11 digits)" />
                <p class="text-danger" v-if="client_number.length > 0 && client_number.length !== 11">
                  Phone number must be exactly 11 digits ({{ client_number.length }})
                </p>
              </div>
              <div class="form-group col-md-6">
                <p>
                  <label for="inputPassword4">Date of Birth <span class="text-danger">*</span></label>
                </p>
                <!-- <date-picker :maximum-view = "currentDate"
                  v-model="newStudent.dob"
                  valueType="format"
                ></date-picker> -->
                <input type="date" :max="currentDate" class="form-control" v-model="newStudent.dob" />
                <!-- <p  class="text-danger">
                  Past date not allowed for Date of Birth
                </p> -->
              </div>
              <!-- <div class="form-group col-md-6">
                <p>
                  <label for="inputPassword4">Expiry Date <span class="text-danger">*</span></label>
                </p>
               
                <input type="date" :min="currentDate" v-model="newStudent.expiry_date" class="form-control" />
              </div> -->

              <!-- <div class="form-group col-md-6">
                <label for="inputEmail4">
                  Staff ID/ Phone Number/NIN
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="newStudent.salary_number"
                  placeholder="Computer Employment Number"
                />
                <p>
                  <strong>
                    Hint: the field is compulsory and needs a unique identifier
                    from the principal.</strong
                  >
                </p>
              </div> -->
            </div>

            <div class="form-row" v-if="sector == 'formal'">
              <div class="form-group col-md-12">
                <label for="inputCity">Select MDA</label>
                <v-select v-model="newStudent.place_of_work" :options="mda_offline.data" label="name"
                  :value="newStudent.place_of_work" @input="selected_mda"></v-select>
              </div>
            </div>

            <div class="row">
              <!-- <div class="form-group col-md-12" v-if="sector == 'informal'">
                <label
                  >Principal Facility for Accessing Health Care
                  <span class="text-danger">*</span></label
                >
                <v-select
                  v-model="newStudent.provider_id"
                  :options="facilities_sync"
                  label="agency_name"
                  :value="newStudent.provider_id"
                  @input="selected_provider"
                ></v-select>
              </div> -->


              <div class="form-group col-md-12">
                <label>Select LGA <span class="text-danger">*</span> </label>

                <select class="form-control" v-model="newStudent.localgovt" @change="getWards()">
                  <option v-for="loc in osun_lgas.data" v-bind:key="loc.id" :value="loc.id">
                    {{ loc.local_name }}
                  </option>
                </select>
              </div>

              <!-- <div class="form-group col-md-12" v-if="sector == 'informal'">
                <label>Select Ward<span class="text-danger">*</span></label>
                <v-select
                  v-model="newStudent.ward"
                  :options="wards_sync"
                  label="ward_name"
                  :value="newStudent.ward"
                  @input="selected_ward"
                ></v-select>
              </div> -->

              <div class="form-group col-md-12">
                <label>Select Ward <span class="text-danger">*</span></label>
                <select class="form-control" v-model="newStudent.ward">
                  <option v-for="loc in wards_lga.wards" v-bind:key="loc.id" :value="loc.id">
                    {{ loc.ward_name }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-12">
                <label>Principal Facility for Accessing Health Care
                  <span class="text-danger">*</span> <button @click="getAllProviders" type="button"
                    class="btn btn-outline-info btn-sm my-1">
                    All
                  </button> </label>
                <v-select v-model="newStudent.provider_id" :options="osun_providers.data" label="agency_name"
                  :reduce="agency_name => agency_name.id" :value="newStudent.provider_id"></v-select>
              </div>

              <div class="col-md-6">
                <label for="inputCity">Gender <span class="text-danger">*</span></label>
                <select class="form-control" v-model="newStudent.gender">
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label for="inputCity">Blood Group</label>
                <select class="form-control" v-model="newStudent.blood">
                  <option value="NA">NA</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="AB">AB</option>
                  <option value="O">O</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label>Marital Status <span class="text-danger">*</span></label>
                <select class="form-control" v-model="newStudent.marital_status">
                  <option value="Married">Married</option>
                  <option value="Widow">Widow</option>
                  <option value="Single">Single</option>
                  <option value="Divorced">Seperated</option>
                  <option value="Divorced">Divorced</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="inputCity">Genotype</label>
                <select class="form-control" v-model="newStudent.genotype">
                  <option value="NA">NA</option>
                  <option value="AA">AA</option>
                  <option value="AS">AS</option>
                  <option value="SS">SS</option>
                  <option value="AC">AC</option>
                </select>
              </div>

              <div class="form-group col-md-12">
                <label for="offlineAddress">Home Address <span class="text-danger">*</span></label>
                <input id="offlineAddress" type="text" class="form-control" v-model="newStudent.address"
                  placeholder="1234 Main St" required />
              </div>

              <div class="form-group col-md-6">
                <label for="offlineOccupation">Occupation <span class="text-danger">*</span></label>
                <v-select input-id="offlineOccupation" v-model="newStudent.occupation" :options="occupations"></v-select>
              </div>

              <div class="form-group col-md-6">
                <label for="offlineEducation">Highest Qualification <span class="text-danger">*</span></label>
                <v-select input-id="offlineEducation" v-model="newStudent.education" :options="qualifications"></v-select>
              </div>
            </div>

            <div class="form-group mt-3">
              <button class="btn btn-submit btn-block btn-lg" @click="showImage" v-if="client_number.length == 11">
                <i class="fe fe-camera mr-2"></i> Proceed to Take Picture
              </button>
              <button class="btn btn-submit btn-block btn-lg" disabled v-else>
                <i class="fe fe-camera mr-2"></i> Proceed to Take Picture
              </button>
            </div>
          </div>
        </div><!-- /card-body -->
      </div><!-- /info-card (form) -->

      <!-- Camera Card -->
      <div class="card info-card shadow-sm mb-4" v-show="showcamera">
        <div class="info-card-header">
          <i class="fe fe-camera mr-2"></i> Client Picture
        </div>
        <div class="card-body">

          <div class="row mb-3">
            <div class="col-6">
              <button class="btn btn-tool btn-block" @click="showInput">
                <i class="fe fe-arrow-left mr-1"></i> Back
              </button>
            </div>
            <div class="col-6">
              <button class="btn btn-submit btn-block" @click="takePicAndroid">
                <i class="fe fe-camera mr-1"></i> Capture / Upload
              </button>
            </div>
          </div>

          <div class="text-center mb-3" v-if="imagefile">
            <img :src="getDisplaySrc(imagefile)" class="rounded capture-preview" alt="Enrollee photo"
              @error="$event.target.src = '/assets/img/claimify_logo.png'" />
            <div class="mt-2 d-flex justify-content-center flex-wrap" style="gap: 8px;">
              <button v-if="photoOriginal" class="btn btn-tool btn-sm" type="button" @click="cropPhoto(photoOriginal)">
                <i class="fe fe-crop mr-1"></i> Adjust photo
              </button>
              <button class="btn btn-outline-danger btn-sm" type="button" @click="removePhoto">
                <i class="fe fe-x mr-1"></i> Remove
              </button>
            </div>
            <p class="text-success small mt-1 mb-0"><i class="fe fe-check-circle mr-1"></i>Photo ready</p>
          </div>

          <button class="btn btn-submit btn-block btn-lg mt-3" @click="addUSer">
            <i class="fe fe-check mr-2"></i> Submit Enrollment
          </button>

          <button class="btn btn-tool btn-block mt-2" v-show="gotoDependent" @click="modalShow = !modalShow">
            <i class="fe fe-user-plus mr-2"></i> Add Dependent
          </button>

          <div>
            <b-modal v-model="modalShow" size="xl">
              <div class="form-row">
                <p class="h4 text-center">
                  Do you want to add Dependent(s) for
                  {{ newStudent.firstname }} {{ newStudent.lastname }}
                </p>
                <div class="row col-md-12 mt-3">
                  <div class="col-md-6">
                    <button class="btn btn-submit btn-block btn-lg" @click="goAddDep">Yes</button>
                  </div>
                  <div class="col-md-6">
                    <button class="btn btn-tool btn-block btn-lg" @click="closeDep">No</button>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>

        </div>
      </div>

    </div><!-- /container -->

    <div class="vld-parent">
      <loading :active.sync="isLoading" loader="spinner" :can-cancel="false" :is-full-page="true"></loading>
    </div>
    <PhotoCropper ref="photoCropper" />
  </div>
</template>
<script>
  import { StudentService } from "../../../service/student_service";
  // import DatePicker from "vue2-datepicker";
  // Import component
  import Loading from "vue-loading-overlay";
  import occupations from "@/json/occupations.json";
  import qualifications from "@/json/qualifications.json";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  import allfacilitiesJson from "./../../../../public/offline/allfacilities.json";
  import lgaswardsJson from "./../../../../public/offline/lgas_wards.json";
  import mdaJson from "./../../../../public/offline/mda.json";
  import tpaJson from "./../../../../public/offline/tpa_data_osun.json";
  import tpaLGAJson from "./../../../../public/offline/lga_tpa.json";
  let agency = JSON.parse(localStorage.getItem("agency"));
  import sectorsJson from "@/json/sectors_dynamic.json";
  import vulnerablesJson from "@/json/vulnerables.json";
  import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
  import { Capacitor } from "@capacitor/core";
  import PhotoCropper from "@/components/PhotoCropper.vue";


  export default {
    components: {
      Loading,
      PhotoCropper,
      // DatePicker,
    },
    name: "Student",
    props: {
      students: {
        required: true,
        type: Array,
      },
    },
    data: function () {
      return {
        selectedDate: "",
        disabled: false,
        modalShow: false,
        gotoDependent: false,
        newStudent: null,
        agency: agency,
        sectors: "",
        vulnerables: "",
        showinput: true,
        showcanvas: true,
        dependents_counter: 0,
        singleuser: "",
        wards: "",
        wards_sync: "",
        facilities_sync: "",
        showcamera: false,
        providers: "",
        imagefile: "",
        imageFilePath: "",
        photoOriginal: "",
        selected_lga_id: "631",
        selected_mda_name: "",
        selected_ward_id: "",
        user: null,
        editStudent: {},
        fullPage: true,
        client_number: "0",
        leftfingers: null,
        rightfingers: null,
        twothumbs: null,
        sector: "informal",
        show: false,
        osun_lgas: lgaswardsJson,
        wards_lga: "",
        osun_providers: allfacilitiesJson,
        mda_offline: mdaJson,
        tpa_offline: tpaJson,
        tpa_Lga: tpaLGAJson,
        isLoading: false,
        occupations: occupations,
        qualifications: qualifications,
        localStudentCount: 0,

        newarray: {
          data: "",
        },
        video_settings: {
          video: {
            width: {
              min: 1280,
              ideal: 1920,
              max: 2560,
            },
            height: {
              min: 720,
              ideal: 1080,
              max: 1440,
            },
            facingMode: "environment",
          },
        },
        service: new StudentService(),
      };
    },

    mounted() {
      //get Facilities By State

      let providers = allfacilitiesJson.data;
      let formatter = providers.filter(
        (x) => x.state == this.agency.state
      );
      this.osun_providers = {
        "data": formatter

      };

      //get LGAs By State
      let lgas = lgaswardsJson.data;
      let formatterLGAs = lgas.filter(
        (x) => x.state_id == this.agency.state
      );
      console.log(formatterLGAs + 'hello');
      this.osun_lgas = {
        "data": formatterLGAs

      };


      //get Agency By ID
      let sectors = sectorsJson;
      let formatterSector = sectors.filter(
        (x) => x.agency_id == this.agency.id
      );
      this.sectors = formatterSector;

      //get Vulnerables By ID
      let vulnerables = vulnerablesJson;
      let formatterVulnerables = vulnerables.filter(
        (x) => x.agency_id == this.agency.id
      );
      this.vulnerables = formatterVulnerables;



    },
    beforeMount: function () {
      this.clear();
      this.user = JSON.parse(localStorage.getItem("user"));
      this.wards_sync = JSON.parse(localStorage.getItem("wards_data"));
      this.facilities_sync = JSON.parse(localStorage.getItem("facilities"));
      this.selected_lga_sync = JSON.parse(localStorage.getItem("selected_lga"));
    },
    computed: {
      getTPA() {
        // let newarr = [1,2, 3].filter(x=> x<2)
        let osunlgaarray = this.tpa_Lga.lgas;
        let formatter = osunlgaarray.filter(
          (x) => x.id == this.newStudent.localgovt
        );
        // this.wards_lga = formatter[0];
        console.log(formatter);
        return formatter[0];
      },
      getplaceofWork() {
        if (this.newStudent.place_of_work == null) {
          return null;
        } else {
          return this.newStudent.place_of_work.name;
        }
      },
      getsalaryNumber() {
        return this.newStudent.salary_number;
      },

      currentDate() {
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, "0");
        let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        let yyyy = today.getFullYear();

        today = yyyy + "-" + mm + "-" + dd;
        return today;
      },
    },

    methods: {

      async persistStorage() {
        if (navigator.storage && navigator.storage.persist) {
          const isPersisted = await navigator.storage.persist();
          console.log(`Persisted storage granted: ${isPersisted}`);
        }
      },
      selected_ward(value) {
        this.selected_ward_id = value.id;
      },
      selected_lga(value) {
        this.selected_lga_id = value.id;
      },
      selected_mda(value) {
        this.selected_mda_name = value.name;
      },
      getAllProviders() {
        let providers = allfacilitiesJson.data;
        let formatter = providers.filter(
          (x) => x.state == this.agency.state
        );
        this.osun_providers = {
          "data": formatter

        };


      },
      getWards() {
        // let newarr = [1,2, 3].filter(x=> x<2)
        let osunlgaarray = this.osun_lgas.data;
        let formatter = osunlgaarray.filter(
          (x) => x.id == this.newStudent.localgovt
        );
        this.wards_lga = formatter[0];
        this.getProviderLGAS();
        console.log(formatter);
      },
      getProviderLGAS() {

        //get Facilities By LGA

        let providers = allfacilitiesJson.data;
        let formatter = providers.filter(
          (x) => x.localgovt == this.newStudent.localgovt
        );
        this.osun_providers = {
          "data": formatter

        };
      },

      showInput() {
        this.showinput = true;
        this.showcamera = false;
        this.showfinger = false;
      },
      showImage() {
        this.showinput = false;
        this.showcamera = true;
        this.streamPic();
      },
      goAddDep() {
        localStorage.setItem(
          "offline_user",
          JSON.stringify(this.newStudent)
        );
        localStorage.setItem("phone_number", this.client_number);
        localStorage.setItem("provider_id", this.newStudent.provider_id);
        this.$router.push("/add/dependent-offline");
      },

      streamPic() {
        let video = document.getElementById("video");
        // Get access to the camera!
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          // Not adding `{ audio: true }` since we only want video now
          navigator.mediaDevices
            .getUserMedia(this.video_settings)
            .then(function (stream) {
              //video.src = window.URL.createObjectURL(stream);
              video.srcObject = stream;
              video.play();
            });
        }
      },
      // Prompt lets the user take a new photo or pick one from the gallery.
      async takePicAndroid() {
        try {
          const image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Uri,
            source: CameraSource.Prompt,
          });

          if (!(await this.cropPhoto(image.webPath))) return;
          this.$toasted.info("Photo ready!", {
            position: "top-center",
            duration: 3000,
          });
        } catch (err) {
          if (err && err.message !== "User cancelled photos app") {
            this.$toasted.error("Could not access camera or gallery.", {
              position: "top-center",
              duration: 3000,
            });
          }
        }
      },
      removePhoto() {
        this.imagefile = "";
        this.imageFilePath = "";
        this.photoOriginal = "";
      },
      // Opens the cropper; the cropped JPEG data URL is stored offline (sync accepts data URLs).
      // Keeps the uncropped photo so it can be adjusted again.
      async cropPhoto(src) {
        const cropped = await this.$refs.photoCropper.open(src);
        if (!cropped) return false;
        this.photoOriginal = src;
        this.imagefile = cropped;
        this.imageFilePath = "";
        return true;
      },
      takePic() {
        this.isLoading = true;
        this.showcanvas = true;
        let video = document.getElementById("video");
        let canvas = document.getElementById("canvas");
        let context = canvas.getContext("2d");

        context.drawImage(video, 0, 0, 500, 350);

        // get image
        let image = new Image();

        image.src = canvas.toDataURL("image/png");
        console.log(image);
        localStorage.setItem("snap", this.imagefile.src);
        this.imagefile = image.src;
        this.isLoading = false;
        this.$toasted.info("Picture taken Successfully", {
          position: "top-center",
          duration: 3000,
        });
      },
      addUSer() {
        this.user = JSON.parse(localStorage.getItem("user"));

        if (this.user.type == "employee") {
          this.addUserEmployee();
        }
      },

      async addUserEmployee() {
        if (!String(this.newStudent.address || "").trim() || !this.newStudent.occupation || !this.newStudent.education) {
          this.$toasted.error("Address, Occupation and Highest Qualification are required", { position: "top-center", duration: 4000 });
          return;
        }
        if (this.newStudent.nimc_number.length !== 11) {
          this.$toasted.error("NIN must be exactly 11 digits", { position: "top-center", duration: 4000 });
          return;
        }
        if (this.client_number.length !== 11) {
          this.$toasted.error("Phone number must be exactly 11 digits", { position: "top-center", duration: 4000 });
          return;
        }
        try {
          // const studentsAdded = await this.service.addStudent(this.newStudent);
          const studentsAdded = await this.service.addStudent({
            // firstname: this.newStudent.firstname,
            firstname: this.newStudent.firstname.toUpperCase(),
            lastname: this.newStudent.lastname.toUpperCase(),
            middlename: this.newStudent.middlename,
            nimc_number: this.newStudent.nimc_number,
            provider_id: this.newStudent.provider_id,
            localgovt: this.newStudent.localgovt,
            plan_type: this.newStudent.plan_type,
            ward: this.newStudent.ward,
            phone_number: this.client_number,
            dob: this.newStudent.dob,
            expiry_date: this.newStudent.expiry_date,
            type: "client",
            gender: this.newStudent.gender,
            user_image: this.imageFilePath || this.imagefile,
            sector: this.newStudent.sector,
            sectorType: this.sector,
            marital_status: this.newStudent.marital_status,
            blood: this.newStudent.blood,
            salary_number: this.getsalaryNumber,
            // place_of_work: this.newStudent.place_of_work.name,
            place_of_work: this.getplaceofWork,
            category_of_vulnerable_group:
              this.newStudent.category_of_vulnerable_group,
            genotype: this.newStudent.genotype,
            occupation: this.newStudent.occupation,
            education: this.newStudent.education,
            address: this.newStudent.address,
            agency_id: this.user.institutional_id,
            enrolled_by: this.user.id,
          });
          this.$emit("add-item", studentsAdded[0]);
          this.localStudentCount++;

          localStorage.removeItem("snap");
          this.imagefile = "";
          this.imageFilePath = "";
          this.photoOriginal = "";
          if (this.newStudent.plan_type != "Family") {
            this.clear();
            this.showInput();
            this.$toasted.info("Client Added Successfully", {
              position: "top-center",
              duration: 3000,
            });
          } else {
            this.modalShow = true;
            this.gotoDependent = true;
          }
        } catch (ex) {
          alert(ex.message);
        }
      },

      closeDep() {
        this.clear();
        this.modalShow = true;
        this.showInput();
      },

      clear() {
        this.newStudent = {
          name: "",
          gender: "",
          client_number: "0",
          country: "",
          city: "",
        };
        localStorage.removeItem("snap");
        this.imagefile = "";
        this.imageFilePath = "";
        this.photoOriginal = "";
        this.client_number = "0";
        this.showcanvas = false;
      },

      getDisplaySrc(path) {
        if (!path) return '/assets/img/claimify_logo.png';
        if (path.startsWith('data:') || path.startsWith('blob:') || path.startsWith('http')) {
          return path;
        }
        try {
          return Capacitor.convertFileSrc(path);
        } catch {
          return path;
        }
      },

      async remove(student) {
        if (confirm('Are you sure you want to delete? to "Confirm upload?')) {
          this.disabled = false;
          const noOfStudentRemoved = await this.service.removeStudent(student.id);
          if (noOfStudentRemoved > 0) {
            this.$emit("remove-item");
            console.log(noOfStudentRemoved);
          }
        }
      },
      async removesync(student) {
        this.disabled = false;
        const noOfStudentRemoved = await this.service.removeStudent(student.id);
        if (noOfStudentRemoved > 0) {
          this.$emit("remove-item");
          console.log(noOfStudentRemoved);
        }
      },
      async update() {
        // debugger;
        const noOfStudentsUpdated = await this.service.updateStudentById(
          this.editStudent
        );
        if (noOfStudentsUpdated > 0) {
          this.cancelUpdate();
          this.$emit("update-item");
        }
      },
      cancelUpdate() {
        this.editStudent = {};
      },
    },
    async created() {
      this.persistStorage();
      this.localStudentCount = await this.service.getStudentCount();
    },
  };
</script>
<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  padding: 36px 40px 56px;
  display: flex;
  align-items: center;
  gap: 18px;
}
.header-icon-wrap {
  background: rgba(255,255,255,0.15);
  border-radius: 14px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
}
.page-header-title  { font-size: 1.6rem; font-weight: 800; margin: 0 0 4px; }
.page-header-subtitle { margin: 0; opacity: .82; font-size: .9rem; }

.alert-sync {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  border-radius: 12px;
  padding: 16px 20px;
}
.btn-sync {
  background: rgba(255,255,255,0.2);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.35);
  border-radius: 8px;
  font-weight: 600;
  font-size: .85rem;
  white-space: nowrap;
  padding: 8px 16px;
  transition: background 0.15s;
}
.btn-sync:hover { background: rgba(255,255,255,0.3); color: #fff; }

.info-card { border-radius: 12px; border: 1px solid #e9ecef; overflow: hidden; }
.info-card-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  font-weight: 600;
  font-size: .85rem;
  padding: 10px 16px;
}

.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  transition: opacity 0.15s;
}
.btn-submit:hover:not(:disabled) { opacity: .88; color: #fff; }
.btn-submit:disabled { opacity: .55; }

.btn-tool {
  background: #f8f9fa;
  color: #1e3a5f;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  font-weight: 600;
  transition: background 0.15s;
}
.btn-tool:hover { background: #e9ecef; color: #1e3a5f; }

.capture-preview {
  max-width: 100%;
  max-height: 320px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
}

#videoElement {
  width: 500px;
  height: 375px;
  background-color: #666;
}
</style>